'use strict'

const _ = require('lodash')
const CompsMigrationHelper = require('../helpers/CompsMigrationHelper')

function patchColumn(pageJson, cache, mobileView, comp) {
    if (mobileView && _.startsWith(comp.designQuery, '#mobile_')) {
        this.deleteComponentDesignData(pageJson, comp)
        comp.designQuery = _.replace(comp.designQuery, 'mobile_', '')
    }
}

const MIGRATION_MAP = {
    'wysiwyg.viewer.components.Column': patchColumn
}

const migrationHelper = new CompsMigrationHelper(MIGRATION_MAP) // eslint-disable-line santa/no-module-state

module.exports = {exec: migrationHelper.migratePage.bind(migrationHelper)}


// WEBPACK FOOTER //
// ./src/plugins/unforkDesignData.js